import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { PosthogService } from '../services/posthog.service';
import { ChatBotFlowSaService } from 'src/app/features/chat-bot/components/ui-chat-bot-sa/chat-bot-flow-sa.service';
import { environment } from 'src/environments/environment';

export const posthogInterceptor: HttpInterceptorFn = (req, next) => {
  const { apiEndpointChatBot, apiEndpointFeedback } = environment.apiServers;

  const isApiRequest =
    (apiEndpointChatBot && req.url.startsWith(apiEndpointChatBot)) ||
    (apiEndpointFeedback && req.url.startsWith(apiEndpointFeedback));

  if (!isApiRequest) {
    return next(req);
  }

  const distinctId = inject(PosthogService).getDistinctId();
  const flowService = inject(ChatBotFlowSaService);
  const funnelId = flowService.getCurrentFunnelId();
  const stepId = flowService.getCurrentStepId();

  const setHeaders: Record<string, string> = {};
  if (distinctId) setHeaders['X-PostHog-Distinct-Id'] = distinctId;
  if (funnelId) setHeaders['X-Funnel-Id'] = funnelId;
  if (stepId !== undefined) setHeaders['X-Step-Id'] = String(stepId);

  if (Object.keys(setHeaders).length === 0) {
    return next(req);
  }

  return next(req.clone({ setHeaders }));
};
